import { render, staticRenderFns } from "./RevenueByOrderChannel.vue?vue&type=template&id=141c39d2"
import script from "./RevenueByOrderChannel.vue?vue&type=script&lang=js"
export * from "./RevenueByOrderChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports